<template>
  <z-dialogo ref="dialogo" titulo="Lançamento no Caixa" :dividers="true" largura="900px" eager persistent>
    <template v-slot:texto>
      <v-form ref="form" v-model="form_valido" lazy-validation>
        <v-row dense>
          <v-col cols="12" sm="3">
            <z-date-picker-menu
              v-model="lancamento.data"
              label="Data"
            ></z-date-picker-menu>
          </v-col>
          <v-col cols="12" sm="9">
            <z-text-field
              v-model="lancamento.historico"
              label="Histórico"
              upper
              ref="historico"
              readonly
              :rules="regras.obrigatorio"
            ></z-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <z-select
              v-model="lancamento.conta_id"
              label="Conta Origem"
              :items="contas"
              :rules="regras.obrigatorio"
            ></z-select>
          </v-col>
          <v-col cols="12" sm="4">
            <z-select
              v-model="lancamento.conta_destino_id"
              label="Conta Destino"
              :items="contasDestino"
              :disabled="lancamento.conta_id === null"
              :rules="regras.obrigatorio"
            ></z-select>
          </v-col>
          <v-col cols="12" sm="4">
            <z-campo-valor
              v-model="lancamento.valor"
              label="Valor"
              :rules="regras.valor"
              ref="valor"
            ></z-campo-valor>
          </v-col>
        </v-row>
      </v-form>
    </template>

    <v-btn text @click="fechar" :disabled="salvando">Cancelar</v-btn>
    <v-btn
      color="primary"
      depressed
      :loading="salvando"
      :disabled="salvando || !form_valido"
      @click="confirmarLancamento"
    >
      {{ lancamento.id ? 'Atualizar' : 'Transferir' }}
    </v-btn>
  </z-dialogo>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance, readonly } from 'vue';
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';


const emit = defineEmits(['fechar', 'abrir']);

const { proxy } = getCurrentInstance()

const dialogo = ref()
const form = ref()
const form_valido = ref(false)
const lancamento = ref({
  data: proxy.$dayjs().format('YYYY-MM-DD'),
  historico: 'Transferência entre contas',
  conta_id: null,
  sede_id: null,
  valor: 0,
  tipo: 'Transferência',
})

const novoLancamento = function() {
  lancamento.value = {
    data: proxy.$dayjs().format('YYYY-MM-DD'),
    historico: 'Transferência entre contas',
    conta_id: null,
    conta_destino_id: null,
    valor: 0,
    tipo: 'Transferência',
  }
}

const regras = {
  obrigatorio: [(v) => !!v || 'Campo obrigatório'],
  valor: [(v) => v != '0,00' || 'O valor não pode ser zero'],
}

const classificacoes = ref([])
const sedes = ref([])
const salvando = ref(false)

onMounted(async () => {

})

const contas = computed(() => {
  return proxy.$store.getters['listas/contas']
})

const contasDestino = computed(() => {
  return contas.value.filter(conta => conta.value !== lancamento.value.conta_id)
})

function onChangeClassificacao() {
  // Carregar contas
}

async function confirmarLancamento() {


  // if (form.value.validate()) {
  //   return false;
  // }

  salvando.value = true;
  try {

    await proxy.$store.dispatch('caixa/transferir', lancamento.value);
    fechar();
  } catch (error) {
    console.error('Não foi possível salvar o lançamento.', error);
    // proxy.$eventbus.erro('Não foi possível salvar o lançamento.', error);
    proxy.$store.dispatch('LOADING_OFF');
  } finally {
    salvando.value = false;
  }

}

const abrir = function() {
  novoLancamento();
  dialogo.value.abrir();
  emit('abrir');
}

const fechar = function() {
  dialogo.value.fechar();
  emit('fechar');
}

defineExpose({
  abrir,
  fechar,
})



</script>

<style lang="scss" scoped>

</style>
